export const ITEMS = 'items';
export const INVOICES = 'invoices';
export const CUSTOMERS = 'customers';
export const ITEM_REPORT = 'itemreport';
export const ORDER_ITEM_REPORT = 'orderitemreport';
export const BATCHES = 'batches';
export const ORDERS = 'orders';
export const INVOICE_ITEMS = 'invoiceitems';
